import { useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { ROLE_LABELS } from "../data/content";

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="space-y-8 max-w-2xl" data-testid="portal-profile-page">
      <div>
        <h1 className="text-2xl font-serif font-semibold text-navy tracking-tight">Profile</h1>
        <p className="mt-1 text-sm text-mutedink">Your account and privacy settings.</p>
      </div>

      <section className="bg-surface border border-line rounded-2xl p-6 shadow-sm" data-testid="profile-card">
        <div className="flex items-center gap-4">
          {user?.picture ? (
            <img src={user.picture} alt="" className="h-14 w-14 rounded-full border border-line" referrerPolicy="no-referrer" />
          ) : (
            <div className="h-14 w-14 rounded-full bg-teal-light flex items-center justify-center text-teal font-serif font-semibold text-xl">
              {user?.name?.[0] || "?"}
            </div>
          )}
          <div>
            <p className="text-base font-sans font-semibold text-navy" data-testid="profile-name">{user?.name}</p>
            <p className="text-sm text-mutedink" data-testid="profile-email">{user?.email}</p>
            <span className="inline-block mt-1 text-[10px] font-bold px-2.5 py-0.5 rounded-full bg-sage-light text-sage">{ROLE_LABELS[user?.role] || user?.role}</span>
          </div>
        </div>
        <dl className="mt-6 space-y-3 text-sm border-t border-line pt-6">
          <div className="flex justify-between">
            <dt className="text-mutedink">Sign-in method</dt>
            <dd className="text-ink font-medium">Google (secure)</dd>
          </div>
          <div className="flex justify-between">
            <dt className="text-mutedink">Member since</dt>
            <dd className="text-ink font-medium">{user?.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}</dd>
          </div>
        </dl>
      </section>

      <section className="bg-sage-light border border-sage/30 rounded-2xl p-6" data-testid="privacy-card">
        <h2 className="text-base font-sans font-semibold text-navy flex items-center gap-2 mb-2"><ShieldCheck className="h-4 w-4 text-sage" /> Your privacy</h2>
        <p className="text-sm text-ink/80 leading-relaxed">
          Your documents and case information are stored in encrypted storage and visible only to you and the team members working on your journey. Sessions expire automatically. Email notifications never contain sensitive case details.
        </p>
      </section>

      <Button onClick={handleLogout} variant="outline" className="border-line text-navy hover:bg-sand rounded-full" data-testid="profile-logout-button">
        <LogOut className="mr-2 h-4 w-4" /> Sign out
      </Button>
    </div>
  );
}
